module.exports = __webpack_public_path__ + "static/img/service_h5_05_zh.888ab9e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/service/service_h5_05_zh.png
// module id = 07AG
// module chunks = 34